'use strict';

import Loader from '../loader/loader';
import { displayErrors, isValidDetails } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class CrudTable {
  constructor() {

  	let $body = $('body'),
  		that = this,
  		tableId,
  		apiUrl,
  		valueId;

  	//ADD
  	$('.js-crud-add').on('click', function(e){
  		e.preventDefault();

  		let $this = $(this),
  			apiUrl = $this.data('add-url'),
  			id = $this.data('id'), // id needed when calling API
  			apiId = $this.data('api-id-name'),
  			$addSection = $this.closest('.crud--add__section'),
  			$requiredInputs = $addSection.find('input, select').filter('[required]:visible'),
  			$inputs = $addSection.find('input, select').filter(':visible'), //todo avoid traversing dom again
  			tableId = $addSection.data('table-id'),
  			dataParams = {};

  		//prevent API call if required input are empty
  		if(!that.isValidForm($this, $requiredInputs))
  			return false;

  		//prepare new values
  		dataParams = that.getNewValues($inputs);
  		// id needed when calling API
        dataParams[apiId] = id;

  		that.addValue(apiUrl, dataParams);

  	});

  	//DELETE
  	$body.on('click', '.js-crud-delete', function (e) {
  		e.preventDefault();

  		let $this = $(this),
        	$tr = $this.closest('tr'),
        	$table = $tr.closest('table');

        valueId = $tr.attr('data-item-id');
        apiUrl = $table.data('delete-url');

  		that.displayConfirmation('#crud-modal-delete');

  	}).on('click', '.js-confirm-crud-delete', function (e) {
        e.preventDefault();

        $.fancybox.close();

        that.deleteValue(apiUrl, valueId);
    });

    //DISPLAY add section
    $('.js-toggle-add-section').on('click', function(e){
    	e.preventDefault();

    	let $section = $(this).closest('.crud').find('.crud--add__section');

    	$section.slideToggle({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    });

  }

  	addValue(apiUrl, dataParams){
  		let loader = new Loader(),
  			that = this;

  		let $table = $('.crud').find('table[data-add-url="' + apiUrl + '"]');

	    loader.fadeIn();
	    $.ajax({
	        url: apiUrl,
	        // url: '/api/delivery-cost' + '?+', //proto for view-tender page
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
	        type: 'POST',
	        data: JSON.stringify(dataParams),
	        success: function (data) {

	        	let rowHTML = '',
	        		values = data.Values,
	        		actions = data.Actions;

	        	//prepare HTML to add a new row to the table
	        	rowHTML += '<tr data-item-id="' + data.Id + '">';

	        	//cell, it assumes data are given in the same order as the columns.
	        	for(let prop in values){
	        		rowHTML += '<td>' + values[prop] + '</td>';
	        	}

	        	//buttons
	        	for(let prop in actions){
	        		let buttonHTML = '';

	        		if(prop === 'hasEdit' && actions[prop])
	        			buttonHTML += '<button type="button" class="btn btncta cta--form cta__tertiary js-crud-edit">Edit</button>';
	        		else if(prop === 'hasDelete' && actions[prop])
	        			buttonHTML += '<button type="button" class="btn btncta cta--form cta__tertiary js-crud-delete">Delete</button>';

	        		rowHTML += '<td>' + buttonHTML + '<t/d>';
	        	}

                rowHTML += '</tr>';

                $table.append(rowHTML);

	            loader.fadeOut();

	            toaster('Value has been created.');
	        },
	        error: function (error) {
	            loader.fadeOut();
	            console.log(error);
	            //TODO: decide where to display error
	        }
	    });
  	}

	deleteValue(apiUrl, valueId){

	  	let loader = new Loader();

	    loader.fadeIn();
	    $.ajax({
	        url: apiUrl + valueId,
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
	        type: 'DELETE',
	        success: function (data) {

	            $('.crud').find('tr[data-item-id=' + valueId + ']').slideUp({
	                duration: 500,
	                easing: 'easeOutExpo',
	                queue: false,
	                complete: function () {
	                    $(this).remove();
	                }
	            });

	            loader.fadeOut();

	            toaster('Value has been deleted.');
	        },
	        error: function (error) {
	            loader.fadeOut();
	            //TODO: decide where to display error
	        }
	    });
	}

  	displayConfirmation(modal){
	  	let isMobileDevice = Modernizr.mq('(max-width: 767px)');

	    $.fancybox.open(modal, {
	        autoSize: false,
	        closeBtn: false,
	        fitToView: false,
	        height: isMobileDevice == true ? 300 : 200,
	        width: isMobileDevice == true ? 250 : 500,
	        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
	        type: 'inline',
	        wrapCSS: 'modal',
	        helpers: {
	            overlay: {
	                locked: true
	            }
	        }
	    });
  	}

  	getNewValues($inputs){
  		let dataParams = {};

  		//todo: validation decimal
        $inputs.each( function(){

        	let $this = $(this),
        		propertyName = $this.attr('id'),
        		value;

  			//define Obj as property name changes according to input
  			if($this.is(":checkbox"))
	    		value = $this.prop('checked');
	    	else
				value = $this.val();

  			dataParams[propertyName] = value;
        });

        return dataParams;
  	}

  	isValidForm($btn, $requiredInputs ){
  		let isValid = false;

        if(isValidDetails($requiredInputs)){
            $btn.removeClass('error');
            isValid = true;
        }
        else
            $btn.addClass('error');

        return isValid;
  	}

}
